import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";

//YATAY;446221;18032025
function WaterlowScore() {
  const { t } = useTranslate();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
    "success"
  );

  const showAlert = (message: string, severity: "error" | "success") => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  useEffect(() => {
    fetchPatientData();
  }, []);

  const handleSaveMedcard = async () => {
    try {
      const response = "Medcard Kaydedildi";
      console.log("Save API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard kaydedilirken hata oluştu!", "error");
    }
  };

  const handleDeleteMedcard = async () => {
    try {
      const response = "Medcard Silindi";
      console.log("Delete API cevabı:", response);
      showAlert(response, "success");
    } catch (error) {
      console.error("Hata:", error);
      showAlert("Medcard silinirken hata oluştu!", "error");
    }
  };

  const fetchPatientData = async () => {
    try {
      const response = "Hasta verileri getirildi.";
      console.log("GetPatientDatas API cevabı:", response);
    } catch (error) {
      console.error("Hata:", error);
    }
  };
  return (
    <>
      <Stack
        sx={{ padding: "5px", marginBottom: "20px" }}
        mt={5}
        direction="row"
        spacing={2}
      >
        <ByzNurseSaveButton onClick={handleSaveMedcard} />
        <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
        <ByzNursePrintButton2 />
      </Stack>

      <Box sx={{ padding: "20px", width: "100%" }}>
        <Grid container spacing={2}>
          <Grid md={6} xs={6} container direction={"column"} spacing={3}>
            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("waterlow-score.title")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  paddingRight: "10px",
                  display: "flex",
                }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("datetime")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiDateTimePicker
                  sx={{ width: "100%", maxWidth: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("createdby")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  disabled
                  label={t("createdby")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("waterlow-score.patient-info")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.gender")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.gender")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.age")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.age")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.weight-loss")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.weight-loss")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.weight-loss-kg")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.weight-loss-kg")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.poor-nutrition")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.poor-nutrition")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("waterlow-score.pressure-sore-risk")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.mobility")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.mobility")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.continence")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.continence")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.skin-type")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.skin-type")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>
                {t("waterlow-score.special-risks")}
              </ByzMuiTypography>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.tissue-malnutrition")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.tissue-malnutrition")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.diabetes-ms-syo")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.diabetes-ms-syo")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.major-surgery-trauma")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.major-surgery-trauma")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px", textAlign: "left" }}  >
                  {t("waterlow-score.high-dose-steroids")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.high-dose-steroids")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.motor-sensory-loss")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.motor-sensory-loss")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid container alignItems="center" justifyContent="space-between">
              <Grid
                md={6}
                xs={6}
                sx={{ borderBottom: "1px solid #E0E0E0", paddingRight: "10px" }}
              >
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("waterlow-score.paraplegia")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6} sx={{ paddingTop: "0px" }}>
                <ByzMuiSelect
                  renderInput={(params : any) => (
                    <ByzMuiTextField
                      {...params}
                      label={t("waterlow-score.paraplegia")}
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "100%", maxWidth: "300px" }}
                  color="info"
                  label={t("select", "uppercase")}
                  placeholder={t("select", "uppercase")}
                />
              </Grid>
            </Grid>

            <Grid
              md={6}
              xs={6}
              sx={{
                backgroundColor: "#F4F7FE",
                borderBottom: "1px solid #E0E0E0",
              }}
            >
              <ByzMuiTypography>{t("other")}</ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("score")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  disabled
                  label={t("score")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ marginLeft: "30px" }}>
                  {t("note")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px" }}
                  color="info"
                  label={t("note")}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <ByzMuiSnackBar
              open={alertOpen}
              onClose={() => setAlertOpen(false)}
              title={
                alertSeverity === "success"
                  ? t("operation-successful")
                  : t("error")
              }
              message={alertMessage}
              type={alertSeverity}
            />
          </Grid>
        </Grid>
      </Box>


    </>
  );
}

export default WaterlowScore;
